import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import classNames from 'classnames'
import {memo, useContext} from 'react'

import type {BuildId} from '../../../../../types'
import {FullLogTarget} from '../../BuildLog.types'
import {TargetContext} from '../../FullBuildLog/FullBuildLog.context'
import {leftPad} from '../BuildLogMessages.utils'

import LogMessageRunningIcon from './LogMessageRunningIcon/LogMessageRunningIcon.container'

import styles from './LogMessageLoading.css'

type Props = {
  className?: string | null | undefined
  buildId?: BuildId
  level?: number | null | undefined
  running?: boolean
}

function LogMessageLoading({className, buildId, level, running}: Props) {
  const target = useContext(TargetContext)
  const isShowRunningIcon = target === FullLogTarget.PAGE || target === FullLogTarget.POPUP

  return (
    <div className={classNames(styles.logMessageLoading, className)}>
      {level != null && leftPad(level)}
      {running === true ? (
        <>
          {isShowRunningIcon && <LogMessageRunningIcon buildId={buildId} />}
          <span className={styles.runningText}>{'Running...'}</span>
        </>
      ) : (
        <LoaderInline>{'Loading...'}</LoaderInline>
      )}
    </div>
  )
}

export default memo(LogMessageLoading)
